module.exports = __webpack_public_path__ + "img/软件企业证书1-2021.6577d8df.png";